import Collapse from '@mui/material/Collapse';
import { useEffect, useState } from 'react';
import { Stack } from 'shell/components';

const AssignmentSettingsPanel = ({ enabled, toggle, children }) => {
    const [detailsVisible, setDetailsVisible] = useState(false);

    useEffect(() => {
        if (!enabled) {
            setDetailsVisible(false);
            return undefined;
        }

        const frame = window.requestAnimationFrame(() => setDetailsVisible(true));
        return () => window.cancelAnimationFrame(frame);
    }, [enabled]);

    return (
        <Stack spacing={5}>
            {toggle}
            <Collapse
                in={enabled}
                orientation={'vertical'}
                collapsedSize={0}
                timeout={{ enter: 500, exit: 400 }}
                easing={{ enter: 'cubic-bezier(0.16, 1, 0.3, 1)', exit: 'cubic-bezier(0.7, 0, 0.84, 0)' }}
                mountOnEnter
                unmountOnExit
            >
                <Stack
                    spacing={5}
                    sx={{
                        opacity: detailsVisible ? 1 : 0.7,
                        transition: 'opacity 220ms cubic-bezier(0.16, 1, 0.3, 1)',
                    }}
                >
                    {children}
                </Stack>
            </Collapse>
        </Stack>
    );
};

export default AssignmentSettingsPanel;
